import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var ConceptBadge = styled.div.withConfig({
  displayName: "ConceptBadgestyle__ConceptBadge",
  componentId: "sc-tre8or-0"
})(["display:inline-flex;width:auto;", ";img{width:auto;", " ", "}"], function (props) {
  return props.onClick && css(["cursor:pointer;"]);
}, mq.sMax(css(["height:", ";"], function (props) {
  return props.$mobileSize ? "".concat(props.$mobileSize, "px") : '30px';
})), mq.s(css(["height:", ";"], function (props) {
  return props.$desktopSize ? "".concat(props.$desktopSize, "px") : '45px';
})));

export { ConceptBadge };
//# sourceMappingURL=ConceptBadge.style.js.map
